Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DatePicker3376443987",
  {"root":"DatePicker3376443987--root"},
  ".DatePicker3376443987--root{display:block}",
  8,
  "DatePicker3376443987"
);
__webpack_require__.stylable.$.register(exports.default)
